const Error = (props) => {
  return <span className="errorMessage" style={{fontSize: "0.9rem"}}>{props.children}</span>;
}

export default Error
